import {
  PLACEMENT_MATCHES,
  RANKED_TIERS,
  TIER_POINTS,
  TOP_TIER,
  type Rank,
  type RankChange,
} from '../../shared/ranked';

/** "Tier 3 · 40 / 100" once placed, "Unranked · 2 of 5 placement matches" before. */
export function rankLabel(rank: Rank): string {
  if (rank.kind === 'unranked')
    return `Unranked · ${rank.placementPlayed} of ${PLACEMENT_MATCHES} placement matches`;
  const points = rank.tier === TOP_TIER ? `${rank.points} pts` : `${rank.points} / ${TIER_POINTS}`;
  return `${RANKED_TIERS[rank.tier]} · ${points}`;
}

/** The tier alone ("Tier 3"), or "Unranked" while placing. */
export function tierName(rank: Rank): string {
  return rank.kind === 'unranked' ? 'Unranked' : RANKED_TIERS[rank.tier]!;
}

/** One line describing what a ranked match did to the player's visible rank. */
export function rankChangeLabel({ before, after }: RankChange): string {
  if (after.kind === 'unranked') return `Placement ${after.placementPlayed} of ${PLACEMENT_MATCHES}`;
  if (before.kind === 'unranked') return `Placed in ${RANKED_TIERS[after.tier]}`;
  if (after.tier > before.tier) return `Promoted to ${RANKED_TIERS[after.tier]}`;
  const delta = after.points - before.points;
  if (delta === 0) return 'No change';
  return `${delta > 0 ? '+' : '−'}${Math.abs(delta)} pts`;
}
